// extracted by mini-css-extract-plugin
module.exports = {"Team":"Team_Team__wcFF3","ContainerTeam":"Team_ContainerTeam__4M6qp","Header":"Team_Header__J3Wfs","People":"Team_People__IIRwo"};